<template>
  <div id="app">
   <router-view :key="$route.fullPath"/>
  </div>
</template>

<script>
import faceLandmarkerManager from "./utils/faceLandmarkerManager";

export default {
  data() {
    return {
      faceLandmarkerState: faceLandmarkerManager.state,
    };
  },
  created() {
    // 兼容现有检测页的 $root.faceMesh 访问，同时公开响应式状态和管理器。
    this.$root.faceMesh = null;
    this.$root.faceMeshManager = faceLandmarkerManager;
    this.$root.faceLandmarkerManager = faceLandmarkerManager;
    this.$root.faceMeshManagerState = this.faceLandmarkerState;
    this.$root.faceLandmarkerState = this.faceLandmarkerState;
    this.initFaceLandmarker();
  },
  watch: {
    "faceLandmarkerState.status": {
      immediate: true,
      handler(status) {
        this.$root.faceMesh =
          status === "ready" ? faceLandmarkerManager.getInstance() : null;
      },
    },
  },
  methods: {
    initFaceLandmarker() {
      // 错误会写入响应式 manager.state，由首页展示并提供重试。
      faceLandmarkerManager.ensureReady().catch((error) => {
        console.error("FaceLandmarker initialization failed", {
          code: error.code,
          phase: error.phase,
          delegate: error.delegate,
        });
      });
    },
  },
  beforeDestroy() {
    this.$root.faceMesh = null;
    faceLandmarkerManager.dispose();
  },
};
</script>


<style lang="scss">
*{
  list-style: none;
  margin: 0;
  padding: 0;
}
html, body, #app {
  height: 100vh;
  height: 100dvh;
  width: 100vw;
  margin: 0;
  padding: 0;
  overflow: hidden;
  box-sizing: border-box;
  touch-action: manipulation;
}

</style>
